import type { Pagination } from '@pba/react-query';
import { type GlobalSearchResultItem, createGlobalSearchResultItems } from 'models';
import { useInfiniteQuery } from 'query';
import { getGlobalSearchResults } from '../services';
import { getGlobalSearchQueryKey } from './keys';

export type GlobalSearchFilter = {
  query?: string;
};

export type GlobalSearchPagination = Pick<Pagination, 'pageSize'>;

type GlobalSearchParams = {
  filter: GlobalSearchFilter;
  pagination: GlobalSearchPagination;
  scope: string;
};

export const useGlobalSearchInfiniteQuery = ({ filter, pagination, scope }: GlobalSearchParams) =>
  useInfiniteQuery<GlobalSearchResultItem[], string | undefined>({
    queryKey: getGlobalSearchQueryKey({ filter, pagination }),
    async queryFn({ pageParam }) {
      const response = await getGlobalSearchResults({
        config: { params: { cursor: pageParam, limit: pagination.pageSize, query: filter.query } },
        routeParams: { scope },
      });
      return createGlobalSearchResultItems(response.data);
    },
    initialPageParam: undefined,
    getNextPageParam(lastPage) {
      return lastPage.at(-1)?.id;
    },
    enabled: Boolean(scope),
    staleTime: 0,
    gcTime: 0,
  });
